import { MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { TranslateService } from '@ngx-translate/core';
var CreateOrEditPendencyDialogComponent = /** @class */ (function () {
    function CreateOrEditPendencyDialogComponent(data, matDialogRef, customMessageService, translateService) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.customMessageService = customMessageService;
        this.translateService = translateService;
        if (!this.data) {
            return;
        }
        this.maintenance = this.data;
    }
    CreateOrEditPendencyDialogComponent.prototype.closeDialogEvent = function (event) {
        if (event.detail.pendency) {
            this.customMessageService.success(this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.MESSAGES.SUCCESSFULLY_SAVED'));
        }
        else if (event.detail.error) {
            this.customMessageService.error(this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.MESSAGES.ERROR_SAVING'));
        }
        this.matDialogRef.close(event.detail);
    };
    return CreateOrEditPendencyDialogComponent;
}());
export { CreateOrEditPendencyDialogComponent };
